<template>
  <modal :show="true" :large="true" v-on:close="closeModal">
    <div slot="title">
      <h4>Add Driver</h4>
      <button
        class="btn-primary btn btn-sm"
        type="button"
        v-on:click="copyClientDetails"
        :disabled="!client"
      >
        Copy Client Details
      </button>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <selectlist
            name="type_id"
            :options="types"
            v-model="driver.type_id"
            label="Driver Type"
            placeholder="Please Select"
            :required="true"
            :show-error="driver.errors.has('type_id')"
            error-message="The driver type is required"
          ></selectlist>

          <inputbox
            v-model="driver.name"
            name="name"
            label="Driver Name"
          ></inputbox>

          <date-of-birth v-model="driver.date_of_birth"></date-of-birth>

          <spinner v-model="driver.convictions" label="Convictions:"></spinner>

          <spinner v-model="driver.points" label="Points:"></spinner>

          <input-block
            name="conviction_details"
            label="Conviction Details"
            v-model="driver.conviction_details"
          ></input-block>

          <spinner
            v-model="driver.accidents_in_three_years"
            label="Accidents Within The Last Three Years:"
          ></spinner>

          <inputbox
            name="driving_licence"
            label="Driving Licence Number"
            v-model="driver.licence_number"
          ></inputbox>

          <div class="form-group">
            <label for="issued_at" class="col-lg-2 control-label"
              >Issue Date:</label
            >
            <div class="col-lg-10">
              <datepicker
                format="dd/MM/yyyy"
                :value="driver.issue_date"
                v-on:selected="setIssuedAtDate"
                input-class="form-control"
                placeholder="dd/mm/yyyy"
              ></datepicker>
            </div>
          </div>

          <div class="form-group">
            <label for="expires_at" class="col-lg-2 control-label"
              >Expiry Date:</label
            >
            <div class="col-lg-10">
              <datepicker
                format="dd/MM/yyyy"
                :value="driver.expiry_date"
                v-on:selected="setExpiresAtDate"
                input-class="form-control"
                placeholder="dd/mm/yyyy"
              ></datepicker>
            </div>
          </div>

          <inputbox v-model="driver.city" name="city" label="City"></inputbox>

          <toggleswitch
            :labels="true"
            name="had_proposal_declined"
            label="Proposal Declined?"
            v-model="driver.had_proposal_declined"
          ></toggleswitch>

          <toggleswitch
            :labels="true"
            name="has_uk_licence"
            label="UK Licence?"
            v-model="driver.has_uk_licence"
          ></toggleswitch>

          <toggleswitch
            :labels="true"
            name="has_new_licence"
            label="Licence Less Than 12 Months Old?"
            v-model="driver.has_new_licence"
          ></toggleswitch>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <form-button :indicator="driver.processing()" v-on:clicked="addDriver"
        >Add New Driver</form-button
      >
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    hire: {
      type: String
    },

    types: {
      type: Array,
      required: true
    },

    client: {
      type: Object
    }
  },

  data() {
    return {
      driver: new window.Form({
        type_id: null,
        name: null,
        date_of_birth: window.DateManager.driverStartingDate(),
        convictions: 0,
        points: 0,
        conviction_details: null,
        accidents_in_three_years: 0,
        licence_number: null,
        issue_date: null,
        expiry_date: null,
        city: null,
        had_proposal_declined: false,
        has_uk_licence: false,
        has_new_licence: false
      })
    };
  },

  methods: {
    copyClientDetails() {
      if (this.client) {
        let name = '';

        if (this.client.first_name) {
          name += this.client.first_name + ' ';
        }

        if (this.client.last_name) {
          name += this.client.last_name;
        }

        this.driver.name = name;
        this.driver.date_of_birth = this.client.date_of_birth
          ? window.DateManager.format(this.client.date_of_birth)
          : null;
        window.toastify.success(
          'Complete',
          "We've copied those details for you."
        );
      }
    },

    closeModal() {
      this.$emit('close');
    },

    addDriver() {
      this.driver
        .post('/hires/' + this.hire + '/drivers')
        .then(response => {
          this.$emit('added', response);
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error creating the driver.'
          );
        });
    },

    setIssuedAtDate(date) {
      this.driver.issue_date = date;
    },

    setExpiresAtDate(date) {
      this.driver.expiry_date = date;
    }
  }
};
</script>
